export default __webpack_public_path__ + "static/media/a026-example2.346584fe.jpg";